module.exports = __webpack_public_path__ + "static/media/d528eeb2-61fa-4056-b015-cb6522f3a57e.3d8d5561.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/certificate-img/completion/d528eeb2-61fa-4056-b015-cb6522f3a57e.png
// module id = 1495
// module chunks = 0